import React, { useState, useRef, useEffect } from "react";
import { SketchPicker } from "react-color";
import styles from "./styles.module.scss";

const BackgroundColor = (props) => {
  const { handleChange, background, className, skew } = props;
  const [showColorPicker, setShowColorPicker] = useState(false);
  const ref = useRef(null);

  const handleClick = () => {
    setShowColorPicker(!showColorPicker);
  };

  const handleClose = () => {
    setShowColorPicker(false);
  };

  useEffect(() => {
    window.addEventListener("click", clickOutside);

    return () => {
      window.removeEventListener("click", clickOutside);
    };
  }, []);

  const clickOutside = (event) => {
    let isDescendant = ref.current?.contains(event.target);

    if (event.target !== ref.current && !isDescendant) {
      setShowColorPicker(false);
    }
  };

  return (
    <div
      className={`${className ? className : styles.swatch}`}
      style={{ position: "relative" }}
      ref={ref}
    >
      <div onClick={handleClick}>
        <div
          className={styles.color}
          style={{
            background: background,
            transform: skew ? "skewX(-10deg)" : "none",
          }}
        />
      </div>
      {showColorPicker ? (
        <div
          className={styles.popover}
          style={{ top: className ? "50px" : "" }}
        >
          <div className={styles.cover} onClick={handleClose} />
          <SketchPicker color={background} onChange={handleChange} />
        </div>
      ) : null}
    </div>
  );
};
export default BackgroundColor;
